import { useEffect } from 'react';

import { PermissionsScheme } from '@/config/types';
import { useSection } from '@/contexts/SectionContext/hooks/useSection';
import { useUserContext } from '@/contexts/UserContext/UserContext';

export const usePermissionsModule = ({ view, edit }: PermissionsScheme) => {
  const { userEntity } = useUserContext();
  const { showSection } = useSection();

  const userType = userEntity?.user.userType;
  const userRoles = userEntity?.user.roles;
  const canView = !!userEntity && userEntity.hasUserType(view);
  const canEdit = edit ? !!userEntity && userEntity.hasRole(edit) : null;

  useEffect(() => {
    if (canView) {
      showSection();
    }
  }, [canView]);

  return { canView, canEdit, userType, userRoles };
};
